import React, { useEffect, useRef, useState } from "react";
import styles from "./ritualpraxis.module.css";
import { Box, Button, Link, Menu, MenuItem, Modal, Typography, useMediaQuery } from "@mui/material";
import Main_chapter from "./components/Main_chapter";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import Head from "next/head";
import CloseIcon from '@mui/icons-material/Close';
import Image from "next/image";
import { useRouter } from 'next/router';

import Chapter_1 from "./components/chapter_1";
import Chapter_2 from "./components/chapter_2";
import Chapter_3 from "./components/chapter_3";
import Chapter_4 from "./components/chapter_4";
import Chapter_5 from "./components/chapter_5";
import Chapter_6 from "./components/chapter_6";
import Chapter_7 from "./components/chapter_7";
import Chapter_8 from "./components/chapter_8";
import Chapter_9 from "./components/chapter_9";
import Chapter_10 from "./components/chapter_10";
import Chapter_11 from "./components/chapter_11";
import Chapter_12 from "./components/chapter_12";
import Chapter_13 from "./components/chapter_13";
import Chapter_14 from "./components/chapter_14";

import amazon_logo from "../../public/image/ritual-praxis-and-instructions/amazon_icon_logo.webp";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

const chaptersMetaData = {
  default: {
    title: "Ritual Praxis and Instructions | School of Our Divine Infinite Being",
    description: "Explore the sacred practices and instructions for ritual praxis in the tradition of Divine Theurgy.",
    keywords: "Ritual Praxis, Theurgy, Sacred Instructions, Divine Practice, Spiritual Guidance",
    ogImage: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp",
    url: "https://www.divineinfinitebeing.com/ritual-praxis-and-instructions",
  },
  '5': {
    title: "Dream Work and Sacred Space | Ritual Praxis | School of Our Divine Infinite Being",
    description: "Learn about dream interpretation, waking within the dream, and the sacred instruments of ritual space including the altar and elemental implements.",
    keywords: "Dream Work, Sacred Space, Altar, Elemental Implements, Theurgy, Ritual Practice",
    ogImage: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp",
    url: "https://www.divineinfinitebeing.com/ritual-praxis-and-instructions?chapter=5",
  }
};

export default function Index() {
  const router = useRouter();
  const { chapter } = router.query;

  const [copyRightOpen, setCopyRightOpen] = useState(false);
  const copyRightModal = () => {
    setCopyRightOpen(true);
  };

  const meta = chaptersMetaData[chapter] || chaptersMetaData.default;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [allComponentViewerState, setAllComponentViewerState] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
    const openbtn = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClosebtn = (index) => {
      if (!isNaN(index)) {
        setAllComponentViewerState(false)
        router.push({
          pathname: '/ritual-praxis-and-instructions',
          query: { chapter: index + 1 },
        })
      }
      setAnchorEl(null);
    };

  const menuItems = [
    { "id": 0, "name": 'Prefaces and Appreciations' },
    { "id": 1, "name": 'Threshold: Awakening into the Starry Realm' },
    { "id": 2, "name": 'Introduction' },
    { "id": 3, "name": 'Eros and the Solar Sacrament of the sacred erotic' },
    { "id": 4, "name": 'The Pulse of the Gods: Drumming, Dancing, Mantra and Trance, the ecstatic mirror of the infinite' },
    { "id": 13, "name": 'Introduction: Preparing the Body and Soul for Celestial Contact' },
    { "id": 5, "name": 'Dream Theurgy, the Prophetic and Divinatory - the forgotten temple of night' },
    { "id": 6, "name": 'Introduction to the Instruments of art and sacred space' },
    { "id": 7, "name": 'Animism, Synchronicity, and the Voice of the World' },
    { "id": 8, "name": 'Theurgic Quantum Solar Salvation' },
    { "id": 9, "name": 'APPENDIX II – Ezekiel ’s Vision as a Solar Polemic: YHWH Enthroned in the Zodiacal Chariot' },
    { "id": 10, "name": 'APPENDIX III – The Conscious Sun: The Enthroned God of our Sector of the Cosmos' },
    { "id": 11, "name": 'APPENDIX IV – The Dawn of the New Aeon' },
    { "id": 12, "name": 'Appendix V – Offerings, Stones, and Icons: A Quick Reference' },
  ]

  const AllComponentViewer = () => {
    setAllComponentViewerState(!allComponentViewerState)
  }


  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(min-width:601px) and (max-width:900px)');

  let logoBanner = '/image/logobanner_desktop.webp';

  if (isMobile) {
    logoBanner = '/image/logobanner.webp';
  } else if (isTablet) {
    logoBanner = '/image/logobanner.webp';
  }


  return (
    <>
      <Head>
        <title>{meta.title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="keywords" content={meta.keywords} />
        <meta name="description" content={meta.description} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={meta.ogImage} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:url" content={meta.url} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:image" content={meta.ogImage} />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <link rel="canonical" href={meta.url} />
      </Head>

      <div className={styles.ritual_praxis_page_main}>
        {/* Banner Section */}
        <div className={styles.ritual_praxis_bnr_main}>
          <div className={styles.ritual_praxis_banner_main_wrpr}>
            <div className={styles.ritual_praxis_banner_left}>

              {/* * * * * * * * * * banner menu chapter * * * * * * * * * *  */}
              <div className={styles.bannerMenu_btn}>
                <Button
                  id="basic-button"
                  aria-controls={openbtn ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openbtn ? 'true' : undefined}
                  onClick={handleClick}
                >
                  List of Chapters<KeyboardArrowDownIcon className={styles.bannerMenu_icon} />
                </Button>
  
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openbtn}
                  onClose={handleClosebtn}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                  className="central_doctrine_yellowNav_menu"
                >
  
                  {menuItems?.map((data, index) => (
                    <MenuItem onClick={() => handleClosebtn(index)} key={index}>{data.name}</MenuItem>
                  ))}
                </Menu>
              </div>
              <Button onClick={() => AllComponentViewer()} className={styles.bannerscroll_btn}>Read as a single scroll</Button>

              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                    alt="View Logo"
                  />
                </span>
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                  alt="School Logo"
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE</h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>
              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div className={`${styles.ritual_praxis_bottombannerbg} ${styles.bannerboxtxt}`}>
                <div className={styles.yellow_bar}></div>
              </div>
            </div>

            <Button className={styles.bnr_green_btn} href="https://www.amazon.com/dp/B0FRMSS6YL?ref=cm_sw_r_ffobk_cp_ud_dp_GN6DWB0FTRWEMP567W26_1&ref_=cm_sw_r_ffobk_cp_ud_dp_GN6DWB0FTRWEMP567W26_1&social_share=cm_sw_r_ffobk_cp_ud_dp_GN6DWB0FTRWEMP567W26_1&bestFormat=true" target="/blank">
              Purchase the book on Amazon
              <div className={styles.amazon_logo}>
                <Image src={amazon_logo} alt="Amazon Logo" />
              </div>
            </Button>
          </div>
        </div>

        <MysteryBannerNew/>

        {/* Main Chapter Content */}
        {allComponentViewerState ? <>
          <Chapter_1 />
          <Chapter_2 />
          <Chapter_3 />
          <Chapter_4 />
          <Chapter_5 />
          <chapter_14 />
          <Chapter_6 />
          <Chapter_7 />
          <Chapter_8 />
          <Chapter_9 />
          <Chapter_10 />
          <Chapter_11 />
          <Chapter_12 />
          <Chapter_13 /></> :
          <div className={styles.ritual_praxis_page_blck_section_main}>
            <Main_chapter allComponentViewerState={allComponentViewerState} />
          </div>
        }

        {/* Logo Modal */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className={styles.banner_modal_main}>
            <Box className={styles.banner_modal_box}>
              <Box className={styles.sub_modal_banner}>
                <Box className={styles.close_btn} onClick={handleClose}>
                  <CloseIcon />
                </Box>
                <Box className={styles.modal_banner}>
                  <img
                    src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                    alt="School Logo Full"
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
}
